import React from "react";
import { Link } from "react-router-dom";

// css
import "../css/App.font.css";
import "../css/AiExpo.css";

// img
import Logo from "../assets/img/logo_white.png";
import arrowBtn from "../assets/img/button_arrow_icon_gray.png";
import imsi01 from "../assets/img/imsi01.jpg";
import imsi02 from "../assets/img/imsi02.jpg";
import imsi03 from "../assets/img/imsi03.jpg";

function AiExpoLLM() {
  const data = [
    {
      image: imsi01,
      title: "기업 특화 LLM 지원",
      items: (
        <>
          <p>기업 환경에 맞춰</p>
          <p>LLM 파인튜닝 지원​</p>
        </>
      ),
    },
    {
      image: imsi02,
      title: "비정형 자료 DB화",
      items: (
        <>
          <p>기업 내・외부 자료를</p>
          <p>지식 기반 체계로 디지털화​</p>
        </>
      ),
    },
    {
      image: imsi03,
      title: "지식 기반 질의 응답",
      items: (
        <>
          <p>환각화(Hallucination) 방지 및</p>
          <p>질의 응답의 내용 품질 향상</p>
        </>
      ),
    },
    {
      image: imsi03,
      title: "개인정보 보호​",
      items: (
        <>
          <p>개인정보 보호​ 및</p>
          <p>기업정보 외부 유출 차단​</p>
        </>
      ),
    },
  ];

  return (
    <div className="wrap">
      <div className="header d-flex">
        <h1 className="heading1">AI EXPO KOREA 2024</h1>
        <img src={Logo} alt="로고 이미지" />
        <p className="contents1">
          &#124;&nbsp;&nbsp;Lead Coexistence of Human and AI in the Workflow
        </p>
      </div>

      <div className="container">
        <div className="main_title">
          <h1 className="heading2">Eurkea LLM & RAG</h1>
          <p className="contents1">
            &#124;&nbsp;&nbsp;인공지능이 업무를 지원하는 미래, 멀지 않은 내일!
            RAG 및 KB 기업 특화 LLM
          </p>
        </div>
        <div className="iframe_wrap"></div>

        <div>
          <h1 className="heading2" style={{ paddingLeft: "20px" }}>
            Features
          </h1>
          <div className="sub_wrap d-flex">
            {data.map((box, index) => (
              <div className="sub_box" key={index}>
                <div className="sub_title4">
                  {box.title.split("\n").map((line, idx) => (
                    <div key={idx}>{line}</div>
                  ))}
                </div>
                <img
                  className="sub_icon"
                  src={box.image}
                  alt={"아이콘 이미지"}
                />
                <div className="contents2">{box.items}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="ai_list_btn">
          <Link to="/aiexpo">
            <button className="btn d-flex">
              <img className="prev_icon" src={arrowBtn} alt="prev icon" />
              영상 목록으로 돌아가기
            </button>
          </Link>
          <Link to="/aiexpoECommerce">
            <button className="btn d-flex">
              Eureka e-Commerce 보러가기{" "}
              <img className="next_icon" src={arrowBtn} alt="arrow icon" />
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AiExpoLLM;
